export const ProductFunnelHeaderName = "X-Product-Funnel";

export const ProductFunnelHeader = {
  Hotels: "premium-stays-hotels",
  VacationRentals: "premium-stays-vacation-rentals",
} as const;

export type ProductFunnelHeader =
  (typeof ProductFunnelHeader)[keyof typeof ProductFunnelHeader];
